// extracted by mini-css-extract-plugin
export var text = "_2q-0";